<!-- search-results.component.html -->
<div class="search-results-container">

  <div class="header-section">
    <!-- <button pButton icon="pi pi-arrow-left" label="Back" (click)="goBack()" class="p-button-text"></button> -->
    <h2>Search Results for "{{ searchQuery }}"</h2>
  </div>

  <div *ngIf="isLoading" class="loading-indicator">
    <!-- <p-progressSpinner></p-progressSpinner> -->
    <p>Searching...</p>
  </div>

  <div *ngIf="!isLoading && searchResults">
    <p-table [value]="flattenedResults" [responsive]="true" [paginator]="true" [rows]="10">
      <ng-template pTemplate="header">
        <tr>
          <th>Module</th>
          <th>Model</th>
          <!-- <th>ID</th> -->
          <th>Field Details</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.module }}</td>
          <td>{{ item.model }}</td>
          <!-- <td>{{ item.pk }}</td> -->
          <td>
            <div *ngFor="let field of objectKeys(item.fields)" class="field-row">
              <strong>{{ field }}:</strong> {{ item.fields[field] }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <p *ngIf="flattenedResults.length === 0" class="no-results">
      No results found for your search.
    </p>
  </div>
</div>